export const roundLoadingMeter = (value?: number | null): string => {
  if (value == null) {
    return "0";
  }

  const rounded = Math.round((Number(value) + Number.EPSILON) * 100) / 100;

  if (isNaN(rounded)) {
    return "0";
  }

  if (!Number.isFinite(rounded)) {
    return "0";
  }

  return rounded.toString().replace(".", ",");
};

export const getLdmPercentage = (
  finishedLdm?: number | null,
  loadingMeter?: number | null
): number => {
  if (!loadingMeter) {
    return 0;
  }

  const percent = Math.round(((finishedLdm ?? 0) / loadingMeter) * 100);

  return Number.isFinite(percent) ? percent : 0;
};
